import { ButtonProps } from '../../components/layout/buttonColor';
import { colors } from '../../plugins/material-ui/themes/onvistaTheme';
import { CASHBACK_WIZARD_START } from './urlConstants';

export const cbWizardStartLink = (attributes?: string) => {
  return `${CASHBACK_WIZARD_START}${attributes ? `?${attributes}` : ''}`;
};

export const buttonStyle = (props: ButtonProps) => {
  return {
    backgroundColor: props.buttonColor ?? colors.sun,
    color: props.buttonFontColor ?? undefined,
  };
};
